import TextField from '@components/v2/form/TextField/TextField';
import { Box } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import useSatisfactionSurveyContentFields from '../hooks/useSatisfactionSurveyContentFields';
import { SATISFACTION_SURVEY_MESSAGE_MAX_LENGTH } from '../satisfactionSurveySettings.consts';
import { SatisfactionSurveySettingsSectionProps } from '../satisfactionSurveySettings.types';
import SatisfactionSurveyQrPreview from './SatisfactionSurveyQrPreview';

const SatisfactionSurveyContentFields = ({
  settings,
  isDisabled,
  isSaving,
  rejectedSaves,
  onChange,
}: SatisfactionSurveySettingsSectionProps) => {
  const { translate } = useTranslation();
  const { url, message, hasInvalidUrl, onUrlFocus, onUrlBlur, onMessageBlur } =
    useSatisfactionSurveyContentFields({ settings, isSaving, rejectedSaves, onChange });

  return (
    <>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <TextField
          sx={{ minWidth: 360, flex: 1 }}
          disabled={isDisabled}
          error={hasInvalidUrl}
          label={translate(LangEnum.SATISFACTION_SURVEY_SETTINGS_URL_LABEL)}
          helperText={translate(
            hasInvalidUrl
              ? LangEnum.SATISFACTION_SURVEY_SETTINGS_URL_INVALID
              : LangEnum.SATISFACTION_SURVEY_SETTINGS_URL_HELPER,
          )}
          value={url.value}
          onFocus={onUrlFocus}
          onChange={(event) => url.setValue(event.target.value)}
          onBlur={onUrlBlur}
        />

        {settings.url && <SatisfactionSurveyQrPreview url={settings.url} />}
      </Box>

      <TextField
        multiline
        minRows={2}
        disabled={isDisabled}
        label={translate(LangEnum.SATISFACTION_SURVEY_SETTINGS_MESSAGE_LABEL)}
        helperText={`${message.value.length}/${SATISFACTION_SURVEY_MESSAGE_MAX_LENGTH}`}
        slotProps={{ htmlInput: { maxLength: SATISFACTION_SURVEY_MESSAGE_MAX_LENGTH } }}
        value={message.value}
        onFocus={message.onFocus}
        onChange={(event) => message.setValue(event.target.value)}
        onBlur={onMessageBlur}
      />
    </>
  );
};

export default SatisfactionSurveyContentFields;
